import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FixedSizeList as List } from "react-window";
import {
  Card,
  CardBody,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
} from "reactstrap";

import { Btn, H2, H3, MUIIcons, P } from "../../../../../AbstractElements";
import {
  ALL_USERS_STATUS,
  EXTERNAL_LEARNER,
  INTERNAL_LEARNER,
  WBT,
} from "../../../../../Api/constants";
import SimpleAccordion from "../../../../../CommonElements/Accordion";
import BorderTabs from "../../../../../CommonElements/BorderTabs";
import Divider from "../../../../../CommonElements/Divider";
import EllipsisWithTooltip from "../../../../../CommonElements/EllipsisWithTooltip";
import LabelTooltip from "../../../../../CommonElements/LabelTooltip";
import CommonModal from "../../../../../CommonElements/Modal";
import MultiProgressBar from "../../../../../CommonElements/MultiProgressBar";
import SliderModal from "../../../../../CommonElements/SliderModal";
import UserProfileCardDetails from "../../../../../CommonElements/UserProfileCardDetails";
import CompletionStatus from "../../../../../container/CompletionStatus";
import DomainInfoCard from "../../../../../container/DominInfoCard";
import EnrolledUserGroups from "../../../../../container/EnrolledUserGroups";
import AssessmentCard from "../../../../../container/GenericCard";
import GenericCard from "../../../../../container/GenericCard";
import OldCourseCard from "../../../../../container/OldCourseCard";
import UserDetailsCard from "../../../../../container/UserDetailsCard";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../ReduxToolkit/Hooks";
import { setLearnerAssessmentDetailsToInitial } from "../../../../../ReduxToolkit/Reducers/AssessmentCatlogSlice";
import { updateCourseStatus } from "../../../../../ReduxToolkit/Reducers/CourseSlice";
import {
  deleteUserOrGroupLearningPlan,
  getLearningPlanById,
  getLearningPlanDetailsById,
  getLearningPlanDetailsByTab,
  modifyTargetDateLearningPlan,
} from "../../../../../ReduxToolkit/Reducers/LearningPlanMaster";
import { getJobRoleList } from "../../../../../ReduxToolkit/Reducers/ManageMasterDataSlice";
import { getUserGroupById } from "../../../../../ReduxToolkit/Reducers/UserGroupSlice";
import { getUsersList } from "../../../../../ReduxToolkit/Reducers/UserSlice";
import { dynamicImage } from "../../../../../Service";
import {
  CreatedOn,
  Remove,
  ModifyTargetDate,
  EditDetails,
  ExportReports,
  LearningPlanDetailsTitle,
  Mins,
  Modify,
  Module,
  New,
  Question,
  Time,
  Type,
  ComingSoon,
  StartDate,
  Select,
  Dates,
  EndDate,
  RemoveUserConfirmation,
  Done,
  SBU,
  RM,
  MarkAsCompleted,
  MarkAsCompletedConfirmation,
  CompletedOn,
  SubmittedOn,
  Start,
  Resume,
  Retake,
  End,
  Questions,
  Modules,
  CoolingPeriod,
  Days,
  FinalScore,
  Overdue,
  Expired,
  UnderReview,
  Note,
  StartNote,
  Add,
  RemoveUserGroupConfirmation,
  Users,
  Webinar,
  Mobile,
} from "../../../../../utils/Constant";
import {
  assessmentStatus,
  assessmentTabStatus,
  assessmentTypesMap,
  assessmentTypesNames,
  calculateDayDifference,
  examStatus,
  formatCustomDate,
  formatDate,
  formatMinutes,
  learningPlanDetailsTabs,
  learningPlanDetailsUserManagementTabs,
  learningPlanMultiProgressData,
  roundToNearestInteger,
  showToast,
} from "../../../../../utils/helper/helper";
import {
  getFromLocalStorage,
  LOGGED_IN_USER,
} from "../../../../../utils/helper/localStorageutils";
import { hasPermissionToComponent } from "../../../../../utils/helper/permission";

const LearningPlanDetails = () => {
  const loginData = getFromLocalStorage(LOGGED_IN_USER);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sliderModalOpen, setSliderModalOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  const learningPlanId = queryParams.get("id");
  const userId = queryParams.get("userId") || "";
  const [activeTab, setActiveTab] = useState("courses");
  const [modalType, setModalType] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [itemSize, setItemSize] = useState(100);
  const [itemSizeForGroups, setItemSizeForGroups] = useState(100);
  const [formValues, setFormValues] = useState({
    start_date: new Date(),
    end_date: new Date(),
  });
  const {
    learningPlanById,
    learningPlanDetailsByTab,
    learningPlanDetailsById,
  } = useAppSelector(state => state.learningPlanMaster);
  const isUserManagement = location.pathname.includes("user-management");
  const [courseData, setCourseData] = useState([]);
  const [assessmentData, setAssessmentData] = useState([]);
  const [userMap, setUserMap] = useState(null);
  const [transformedData, setTransformedData] = useState({});
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const { usersList } = useAppSelector(state => state.user);
  const { jobRoleList } = useAppSelector(state => state.manageMasterData);
  const { userGroupById } = useAppSelector(state => state.userGroup);

  useEffect(() => {
    if (learningPlanId) {
      dispatch(getLearningPlanById({ id: learningPlanId }));
    }
  }, [dispatch, learningPlanId]);

  useEffect(() => {
    const userMapObj = {};
    usersList?.users?.forEach(user => {
      userMapObj[user.id] = user;
    });
    setUserMap(userMapObj);
  }, [usersList]);

  useEffect(() => {
    if (jobRoleList?.job_role && Array.isArray(jobRoleList?.job_role)) {
      const result = jobRoleList?.job_role.reduce((acc, item) => {
        acc[item.id] = {
          name: item.name,
          industry_name: item.industry_name,
        };
        return acc;
      }, {});
      setTransformedData(result);
    }
  }, [jobRoleList]);

  const updateItemSize = () => {
    const width = window.innerWidth;
    if (width <= 767) {
      setItemSize(200);
      setItemSizeForGroups(170);
    } else if (width <= 1023) {
      setItemSize(150);
      setItemSizeForGroups(120);
    } else {
      setItemSize(100);
      setItemSizeForGroups(70);
    }
  };

  useEffect(() => {
    updateItemSize();
    window.addEventListener("resize", updateItemSize);
    return () => {
      window.removeEventListener("resize", updateItemSize);
    };
  }, []);

  useEffect(() => {
    if (hasPermissionToComponent("USER_MANAGEMENT.TM_LEARNING_PLAN")) {
      dispatch(getUsersList({ role: ALL_USERS_STATUS }));
      dispatch(getJobRoleList());
    }
  }, [dispatch]);

  const getTabData = async () => {
    await dispatch(
      getLearningPlanDetailsById({ id: learningPlanId, user_id: userId })
    );
    await dispatch(
      getLearningPlanDetailsByTab({
        id: learningPlanId,
        tab: activeTab,
        userId: userId,
      })
    );
  };

  useEffect(() => {
    if (learningPlanId && activeTab) {
      getTabData();
    }
  }, [learningPlanId, activeTab]);

  useEffect(() => {
    if (learningPlanDetailsByTab?.courses) {
      setCourseData(learningPlanDetailsByTab?.courses);
    }
    if (learningPlanDetailsByTab?.assessments) {
      setAssessmentData(learningPlanDetailsByTab?.assessments);
    }
  }, [learningPlanDetailsByTab]);

  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
  };

  const extractJobRoleName = ids =>
    ids?.map(id => transformedData[id]?.name || null);

  const jobRoleNames = extractJobRoleName(
    learningPlanDetailsById?.job_roles || []
  );
  const jobDomainNames = ids => {
    return ids?.map(id => id?.name || null);
  };

  const accordionData = [
    {
      id: "1",
      accordionItemClass: "item-class",
      accordionHeaderClass: "header-class",
      spanClass: "span-class",
      iconWithTitle: <span>Icon with title</span>,
      accordionHeading: LearningPlanDetailsTitle,
      icon: true,
      bodyText: (
        <Row>
          {[
            {
              label: "Domain",
              value: (
                <EllipsisWithTooltip
                  textList={
                    learningPlanDetailsById &&
                    learningPlanDetailsById?.domains &&
                    learningPlanDetailsById?.domains?.map(item => item.name)
                  }
                  idPrefix="tool-tip-domain"
                />
              ),
              icon: "BuildOutlined",
              show: !!userId || !isUserManagement,
            },
            {
              label: "Job Role",
              value: (
                <EllipsisWithTooltip
                  textList={jobRoleNames}
                  idPrefix="job-role"
                />
              ),
              icon: "PersonOutlined",
              show: !!userId || !isUserManagement,
            },
            {
              label: "Level",
              value: learningPlanDetailsById?.level,
              icon: "MilitaryTechOutlined",
              show: !!userId || !isUserManagement,
            },
            {
              label: "No. of Users",
              value: learningPlanDetailsById?.users,
              icon: "PeopleOutlined",
              show: !!userId || !isUserManagement,
            },
            {
              label: "Duration",
              value: formatMinutes(learningPlanDetailsById?.total_duration),
              icon: "QueryBuilderOutlined",
              show: true,
            },
            {
              label: "Created On",
              value: formatCustomDate(learningPlanDetailsById?.created_on),
              icon: "CalendarTodayOutlined",
              show: !!userId || !isUserManagement,
            },
            {
              label: "Target Date",
              value: formatCustomDate(learningPlanDetailsById?.target_date),
              icon: "CalendarTodayOutlined",
              show: !userId && isUserManagement,
            },
            {
              label: "Created By",
              value: userMap
                ? userMap[learningPlanDetailsById?.created_by]?.user_name
                : null,
              icon: "PersonOutlined",
              show: !!userId || !isUserManagement,
            },
          ]
            .filter(item => item.show !== false)
            .map((item, index) => (
              <Col lg="12" md="12" sm="12" xs="12" key={index}>
                <DomainInfoCard
                  label={item.label}
                  value={item.value}
                  icon={<MUIIcons size={20} iconName={item.icon as any} />}
                />
              </Col>
            ))}
        </Row>
      ),
    },
  ];

  const total = learningPlanDetailsById?.progress?.total || 0;

  const progressStats = [
    {
      label: "Completed",
      percentage: total ? learningPlanDetailsById?.progress?.completed : 0,
      statusColor: "green",
    },
    {
      label: "Inprogress",
      percentage: total ? learningPlanDetailsById?.progress?.in_progress : 0,
      statusColor: "yellow",
    },
    {
      label: "Yet to Start",
      percentage: total ? learningPlanDetailsById?.progress?.yts : 0,
      statusColor: "gray",
    },
  ];

  const handleNavigate = type => {
    return navigate(
      `${process.env.PUBLIC_URL}/master-data/create-learning-plan?id=${learningPlanId}&show=${type}`
    );
  };

  const handleAddNavigate = () => {
    return navigate(
      `${process.env.PUBLIC_URL}/master-data/learning-plan/add-user-detail`,
      {
        state: {
          learningPlanId: learningPlanId,
          enrolledUsersIds:
            learningPlanDetailsByTab?.enrolled_users?.map(item => item?.id) ||
            [],
          enrolledUserGroupIds:
            learningPlanDetailsByTab?.enrolled_user_groups?.map(item =>
              item?.id?.toString()
            ) || [],
          type:
            activeTab === "users" || activeTab === "user_groups"
              ? activeTab
              : "users",
        },
      }
    );
  };

  const toggleModal = () => {
    if (isModalOpen) {
      setModalType("");
      setSelectedId("");
      setIsModalOpen(false);
      setFormValues({
        start_date: new Date(),
        end_date: new Date(),
      });
    } else {
      setIsModalOpen(true);
    }
  };

  const toggleSliderModal = () => {
    setSliderModalOpen(!sliderModalOpen);
  };

  const getChangedDate = date => {
    const newDate = new Date(date);
    if (Number(learningPlanById.duration) > 0) {
      newDate.setDate(
        newDate.getDate() + (Number(learningPlanById.duration) - 1)
      );
    }
    return newDate;
  };

  const handleDateChange = (name: string, date: Date) => {
    setFormValues(prevState => ({
      ...prevState,
      end_date: name === "start_date" ? getChangedDate(date) : date,
      start_date: name === "start_date" ? date : prevState?.start_date,
    }));
  };

  const renderModalBody = () => {
    if (modalType === "modify_target_date") {
      return (
        <Row>
          <Col md={6}>
            <LabelTooltip
              label={StartDate}
              tooltipText={`${Select} ${StartDate}`}
              important={true}
            />
            <div className={"w-100"}>
              <DatePicker
                selected={formValues?.start_date}
                onChange={(date: Date | null) =>
                  handleDateChange("start_date", date)
                }
                minDate={new Date()}
                placeholderText={`${Select} ${Dates}`}
                className={"form-control"}
                dateFormat="dd-MM-yyyy"
                disabledKeyboardNavigation={true}
                onKeyDown={e => e.preventDefault()}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
              />
            </div>
          </Col>

          <Col md={6}>
            <LabelTooltip
              label={EndDate}
              tooltipText={`${Select} ${EndDate}`}
              important={true}
              placement={"bottom"}
            />
            <div className={"w-100"}>
              <DatePicker
                selected={formValues?.end_date}
                onChange={(date: Date | null) =>
                  handleDateChange("end_date", date)
                }
                minDate={formValues?.start_date || new Date()}
                placeholderText={`${Select} ${Dates}`}
                className={"w-100 form-control"}
                dateFormat="dd-MM-yyyy"
                disabledKeyboardNavigation={true}
                onKeyDown={e => e.preventDefault()}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
              />
            </div>
          </Col>
        </Row>
      );
    }
    if (modalType === "remove_user") {
      return <P>{RemoveUserConfirmation}</P>;
    }
    if (modalType === "remove_user_group") {
      return <P>{RemoveUserGroupConfirmation}</P>;
    }
    if (modalType === "mark_as_completed") {
      return <P>{MarkAsCompletedConfirmation}</P>;
    }
  };

  let sizeTitle = "";
  if (modalType === "modify_target_date") {
    sizeTitle = ModifyTargetDate;
  } else if (modalType === "remove_user" || modalType === "remove_user_group") {
    sizeTitle = Remove;
  } else if (modalType === "mark_as_completed") {
    sizeTitle = MarkAsCompleted;
  }

  const isUpcomingExam = dateString => {
    if (!dateString) {
      return false;
    }
    const inputDate = new Date(dateString);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return inputDate > today;
  };

  const getButtonTitle = status => {
    if (status === assessmentStatus.inProgress) {
      return Resume;
    } else if (status === assessmentStatus.yetToStart) {
      return Start;
    } else if (status === assessmentStatus.retake) {
      return Retake;
    }
  };

  const handleExam = assessment => {
    if (assessment?.assessment_type === assessmentTypesMap.competency) {
      dispatch(setLearnerAssessmentDetailsToInitial());
      return navigate("/self-assessment", {
        state: {
          participantId: assessment?.participant_id,
        },
      });
    }
    if (assessment?.status === assessmentStatus.yetToStart) {
      //Came via Start
      return navigate("/assessment-instruction", {
        state: {
          participantId: assessment?.participant_id,
          name: assessment?.name,
          termsAndCondition: assessment?.term_and_condition,
        },
      });
    } else {
      //Came via Resume
      return navigate("/learning-assessment", {
        state: {
          participantId: assessment?.participant_id,
          name: assessment.name,
        },
      });
    }
  };

  const getTabStatus = assessment => {
    const { start_date, status } = assessment;
    if (
      status === examStatus.failed ||
      status === examStatus.passed ||
      userId
    ) {
      return assessmentTabStatus.past;
    }
    if (isUpcomingExam(start_date)) {
      return assessmentTabStatus.upcoming;
    }
  };

  const handleClick = item => {
    if (!hasPermissionToComponent("TA_ASSESSMENT_DETAILS")) {
      return;
    }

    const restricted =
      item?.status !== assessmentStatus.overdue &&
      item?.status !== assessmentStatus.expired;

    if (
      [EXTERNAL_LEARNER, INTERNAL_LEARNER].includes(loginData.currentRole) &&
      restricted
    ) {
      return navigate("/assessment-list/assessment-details", {
        state: {
          assessment: item,
          activeTab: getTabStatus(item),
          hideAction: userId,
          showExtension: true,
        },
      });
    }

    if (restricted)
      return navigate(
        `/assessments/assessment-details?assessmentId=${item.assessment_id}`
      );
  };

  const renderAssessmentCard = assessment => {
    const {
      participant_id,
      name,
      start_date,
      end_date,
      estimated_time,
      cooling_period_date,
      module_count,
      overall_question_count,
      end_time,
      score,
      status,
      assessment_type,
    } = assessment;
    const coolingPeriod = calculateDayDifference(cooling_period_date);

    const footerDate = (() => {
      if (
        assessment?.status === assessmentStatus.overdue ||
        assessment?.status === assessmentStatus.expired
      ) {
        return "-";
      }
      if (
        status === examStatus.passed ||
        status === examStatus.failed ||
        status === examStatus.completed
      ) {
        return `${CompletedOn} ${formatCustomDate(end_time)}`;
      } else if (status === examStatus.under_review) {
        return `${SubmittedOn} ${formatCustomDate(end_time)}`;
      }
      return null;
    })();

    const getButtonType = assessment => {
      const { status, cooling_period_date } = assessment;
      const coolingPeriod = calculateDayDifference(cooling_period_date);
      const isCoolingPeriod = coolingPeriod > 0;

      if (
        status === examStatus.under_review ||
        status === examStatus.failed ||
        status === examStatus.passed ||
        status === examStatus.completed ||
        userId
      ) {
        return null;
      }

      if (isUpcomingExam(start_date)) {
        return {
          title: Start,
          onClick: () => {
            return;
          },
          disabled: true,
        };
      }

      if (
        status === assessmentStatus.yetToStart ||
        status === assessmentStatus.inProgress
      ) {
        return {
          title: getButtonTitle(status),
          disabled: isCoolingPeriod,
          onClick: isCoolingPeriod
            ? () => {
                return;
              }
            : () => handleExam(assessment),
        };
      }

      return null;
    };

    return (
      <div>
        <button
          className={`border-0 bg-transparent pointer p-0 w-100 text-start ${!hasPermissionToComponent("TA_ASSESSMENT_DETAILS") ? "pointer-unset" : ""}`}
          onClick={() => handleClick(assessment)}
        >
          <GenericCard
            id={participant_id}
            header={name}
            moduleDetails={[
              {
                label: Start,
                value: start_date ? formatCustomDate(start_date) : "-",
                key: `${participant_id}_${Start}`,
              },
              {
                label: End,
                value: end_date ? formatCustomDate(end_date) : "-",
                key: `${participant_id}_${End}`,
              },
              {
                label: Time,
                value: estimated_time ? `${estimated_time} ${Mins}` : "-",
                key: `${participant_id}_${Time}`,
              },
              {
                label: Questions,
                value: overall_question_count ?? "-",
                key: `${participant_id}_${Questions}`,
              },
              {
                label: Modules,
                value: module_count ?? "-",
                key: `${participant_id}_${Modules}`,
              },
            ]}
            isHideMoreOption={true}
            footerBadgeRight={
              coolingPeriod &&
              (status !== examStatus.passed || status !== examStatus.failed)
                ? `${CoolingPeriod} ${coolingPeriod} ${Days}`
                : ""
            }
            footerBadge={(() => {
              if (assessment_type !== assessmentTypesMap.competency) {
                if (
                  status === examStatus.passed ||
                  status === examStatus.failed
                ) {
                  return `${FinalScore} ${roundToNearestInteger(score)}%`;
                }
              }
              if (status === assessmentStatus.overdue) {
                return Overdue;
              }
              if (status === assessmentStatus.expired) {
                return Expired;
              }
              return status === examStatus?.under_review ? UnderReview : "";
            })()}
            footerBadgeStatus={(() => {
              if (status === examStatus.passed) {
                return "completed";
              }
              if (status === examStatus.under_review) {
                return "draft";
              }
              if (
                status === examStatus.failed ||
                status === assessmentStatus.overdue ||
                status === assessmentStatus.expired
              ) {
                return "rejected";
              }
              return "";
            })()}
            btnType={getButtonType(assessment)}
            altText={
              assessment?.assessment_type !== assessmentTypesMap.competency &&
              isUpcomingExam(start_date)
                ? `${Note}: ${StartNote}`
                : null
            }
            footerDate={footerDate}
          />
        </button>
      </div>
    );
  };

  const shouldShowDrop = course => {
    const isPermitted = hasPermissionToComponent(
      "USER_MANAGEMENT.APPROVE_MODIFIED_YEAR"
    );
    const isCorrectType =
      course?.course_type === WBT || course?.course_type === Webinar;
    const isNotCompleted = course?.status !== "completed";

    return isUserManagement && isPermitted && isCorrectType && isNotCompleted;
  };

  const handleClickCourse = item => {
    if (!isUserManagement) {
      return navigate(`/course-management/course-details?courseId=${item.id}`);
    }
    const baseUrl = `/my-learning-plan/course-details?course_id=${item.id}`;
    const url = userId
      ? `${baseUrl}&user_id=${userId}`
      : `${baseUrl}&learning_plan=${item?.learning_plan_completion_id}`;
    navigate(url);
  };

  return (
    <div className="page-body">
      <SliderModal
        isOpen={sliderModalOpen}
        toggle={() => {
          toggleSliderModal();
        }}
      >
        <>
          <H3 className="mt-3">{userGroupById?.name}</H3>
          <P className="text-muted mt-2">
            {userGroupById?.users?.length} {Users}
          </P>
          <Divider />
          <>
            {userGroupById?.users?.map(items => {
              return (
                <>
                  <div className="mt-2">
                    <UserDetailsCard
                      userDetails={{
                        id: items,
                        name: userMap ? userMap[items]?.user_name : null,
                        empId: userMap ? userMap[items]?.employee_code : null,
                        mobile: userMap ? userMap[items]?.phone : null,
                      }}
                      showGap={false}
                    />
                    <Row className="text-muted mt-3">
                      <Col
                        lg="4"
                        md="4"
                        sm="12"
                        xs="12"
                        className="d-flex gap-2"
                      >
                        <MUIIcons iconName="BadgeOutlined" size={20} />
                        <span>
                          {SBU}:
                          <span>
                            {userMap ? userMap[items]?.sbu || "-" : null}
                          </span>
                        </span>
                      </Col>
                      <Col className="d-flex gap-2">
                        <MUIIcons iconName="PersonOutline" size={20} />
                        <div>
                          <div>
                            {RM}{" "}
                            {userMap
                              ? userMap[items]?.mapped_rm?.[0]?.name || "-"
                              : null}
                          </div>
                          <div>
                            {Mobile}:{" "}
                            {userMap
                              ? userMap[items]?.mapped_rm?.[0]?.rm_phone || "-"
                              : null}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <Divider />
                </>
              );
            })}
          </>
        </>
      </SliderModal>
      <CommonModal
        sizeTitle={sizeTitle}
        modalBodyClassName=""
        isOpen={isModalOpen}
        toggle={toggleModal}
        backdrop="static"
        size="lg"
        showFooter={true}
        primaryBtnText={Done}
        onPrimaryBtnClick={async () => {
          if (modalType === "remove_user") {
            await dispatch(
              deleteUserOrGroupLearningPlan({
                id: learningPlanId,
                type: "users",
                payload: {
                  users: [selectedId],
                },
              })
            );
          }
          if (modalType === "remove_user_group") {
            await dispatch(
              deleteUserOrGroupLearningPlan({
                id: learningPlanId,
                type: "user_groups",
                payload: {
                  user_groups: [selectedId],
                },
              })
            );
          }
          if (modalType === "modify_target_date") {
            const payload = {
              id: learningPlanId,
              [activeTab === "users" ? "user_id" : "group_id"]: selectedId,
              start_date: formatDate(formValues?.start_date),
              end_date: formatDate(formValues?.end_date),
            };

            await dispatch(
              modifyTargetDateLearningPlan({
                type:
                  activeTab === "users"
                    ? "modify_target_date_users"
                    : "modify_target_date_user_group",
                payload,
              })
            );
          }

          if (modalType === "mark_as_completed") {
            const payload = {
              learning_plan_completion_id: parseInt(selectedCourseId),
              user_id: userId,
              status: "completed",
              type: "learning_plan",
            };
            await dispatch(
              updateCourseStatus({
                courseStatus: payload,
              })
            );
          }

          await getTabData();
          toggleModal();
        }}
      >
        {renderModalBody()}
      </CommonModal>
      <Row>
        <Col lg="8" md="12" sm="12" xs="12">
          <Card className="p-2">
            <CardBody>
              <div className="d-flex justify-content-between">
                <H3 className="fw-bold">{learningPlanDetailsById?.name}</H3>
                {!isUserManagement && (
                  <Dropdown
                    isOpen={dropdownOpen}
                    toggle={() => setDropdownOpen(prev => !prev)}
                  >
                    <DropdownToggle
                      tag="span"
                      className="pointer primary-icon-color"
                    >
                      <MoreVertIcon />
                    </DropdownToggle>
                    <DropdownMenu end>
                      <DropdownItem onClick={() => handleNavigate("details")}>
                        {EditDetails}
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => {
                          showToast(ComingSoon, "warning");
                        }}
                      >
                        {ExportReports}
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                )}
              </div>
              <P className="text-muted mt-3">
                {learningPlanDetailsById?.description}
              </P>
              <div className="mt-4 d-flex justify-content-between">
                <BorderTabs
                  showCard={false}
                  tabs={
                    isUserManagement
                      ? learningPlanDetailsUserManagementTabs
                      : learningPlanDetailsTabs
                  }
                  activeTab={activeTab}
                  handleTabClick={handleTabClick}
                />
                {!isUserManagement &&
                  ["courses", "assessment"].includes(activeTab) && (
                    <Btn
                      onClick={() => {
                        handleNavigate("people");
                      }}
                      color="primary"
                    >
                      {Modify}
                    </Btn>
                  )}
                {!isUserManagement &&
                  ["users", "user_groups"].includes(activeTab) && (
                    <Btn
                      onClick={() => {
                        handleAddNavigate();
                      }}
                      color="primary"
                    >
                      {`+  ${Add}`}
                    </Btn>
                  )}
              </div>
              {activeTab === "courses" && (
                <Row className="mt-3">
                  {courseData.map((course, idx) => (
                    <Col lg="6" md="6" sm="12" xs="12" key={idx}>
                      <div onClick={() => handleClickCourse(course)}>
                        <OldCourseCard
                          userNameMap={null}
                          course_id={course.id}
                          title={jobDomainNames(course?.domains)}
                          header={course.name}
                          rm=""
                          requestedOn={formatCustomDate(course.published_date)}
                          status={course.status}
                          levels={course.level}
                          type={course.course_type}
                          range={`${course?.min_attendance ? course?.min_attendance : 0}-${course?.max_attendance ? course?.max_attendance : 0}`}
                          assignments={[]}
                          showTrainer={false}
                          showDrop={shouldShowDrop(course)}
                          dropVal={
                            shouldShowDrop(course)
                              ? [
                                  {
                                    courseId: course.course_id,
                                    name: MarkAsCompleted,
                                  },
                                ]
                              : []
                          }
                          onDropClick={() => {
                            setModalType("mark_as_completed");
                            setSelectedCourseId(
                              course?.learning_plan_completion_id
                            );
                            toggleModal();
                          }}
                        />
                      </div>
                    </Col>
                  ))}
                </Row>
              )}
              {activeTab === "assessment" && (
                <Row className="mt-3 assessment-catlog-list catlog-assessments ">
                  {assessmentData?.map((assessment, idx) => (
                    <Col lg="6" md="6" sm="12" xs="12" key={idx}>
                      {isUserManagement ? (
                        renderAssessmentCard(assessment)
                      ) : (
                        <Link
                          to={`/assessments/assessment-details?assessmentId=${assessment?.id}`}
                        >
                          <AssessmentCard
                            id={idx.toString()}
                            header={assessment.name}
                            userCardWithoutDetail={{
                              imagePath:
                                userMap[assessment.owner_id]?.profile_url ||
                                dynamicImage("profile/user_profile.png"),
                              name:
                                userMap[assessment.owner_id]?.user_name || null,
                            }}
                            footerBadge={""}
                            footerDate={`${CreatedOn} ${formatCustomDate(assessment.created_at)}`}
                            isHideMoreOption
                            moduleDetails={[
                              {
                                label: Type,
                                value: assessmentTypesNames[assessment.type],
                                key: `${assessment.id}_${Type}`,
                              },
                              {
                                label: Question,
                                value: assessment?.question_count?.toString(),
                                key: `${assessment.id}_${Question}`,
                              },
                              {
                                label: Module,
                                value: assessment?.module_count?.toString(),
                                key: `${assessment.id}_${Module}`,
                              },
                              {
                                label: Time,
                                value: assessment.duration
                                  ? `${assessment.duration}${Mins}`
                                  : "-",
                                key: `${assessment.id}_${Time}`,
                              },
                            ]}
                          />
                        </Link>
                      )}
                    </Col>
                  ))}
                </Row>
              )}
              {activeTab === "users" && (
                <List
                  height={200}
                  itemCount={
                    learningPlanDetailsByTab?.enrolled_users?.length || 0
                  }
                  itemSize={itemSize}
                  width="100%"
                  className="user-list__card-container"
                >
                  {({ index, style }) => {
                    const enrolledUser =
                      learningPlanDetailsByTab?.enrolled_users?.[index];
                    const seriesId = enrolledUser?.id;

                    const user: any = {
                      id: seriesId,
                      name: userMap[seriesId]?.user_name,
                      userProfileUrl:
                        userMap[seriesId]?.profile_url ||
                        dynamicImage("profile/user_profile.png"),
                      rmName: userMap[seriesId]?.mapped_rm?.[0]?.name || "-",
                      rmPhoneNumber:
                        userMap[seriesId]?.mapped_rm?.[0]?.rm_phone || "-",
                      phoneNumber: userMap[seriesId]?.phone || "-",
                      mailId: userMap[seriesId]?.email || "-",
                      empId: userMap[seriesId]?.employee_code,
                      sbu: userMap[seriesId]?.sbu || "-",
                      job_role_id: userMap[seriesId]?.jobe_role_id,
                      tag: false,
                      showDrop: true,
                      dropVal: [Remove, ModifyTargetDate],
                    };

                    return (
                      <div
                        key={seriesId || index}
                        style={style}
                        className="pointer user-list__card"
                      >
                        <UserProfileCardDetails
                          {...user}
                          showDrop
                          showMail={false}
                          uniqueKey={user.id}
                          onDropClick={(_, val) => {
                            if (val === Remove) {
                              setModalType("remove_user");
                            } else {
                              setFormValues({
                                start_date: new Date(enrolledUser?.start_date),
                                end_date: new Date(enrolledUser?.end_date),
                              });
                              setModalType("modify_target_date");
                            }
                            setSelectedId(seriesId);
                            toggleModal();
                          }}
                          badgeText={user?.is_new_user ? New : null}
                        />
                      </div>
                    );
                  }}
                </List>
              )}
              {activeTab === "user_groups" && (
                <List
                  height={200}
                  itemCount={
                    learningPlanDetailsByTab?.enrolled_user_groups?.length || 0
                  }
                  itemSize={itemSizeForGroups}
                  width="100%"
                  className="user-list__card-container mt-2"
                >
                  {({ index, style }) => {
                    const seriesId =
                      learningPlanDetailsByTab?.enrolled_user_groups?.[index];

                    const groupData = {
                      heading: seriesId?.name,
                      noOfGroups: seriesId?.users || 0,
                      noOfAddedGroups: seriesId?.added_to_lp || 0,
                      createdBy: userMap[seriesId?.created_by]?.user_name,
                      addedOn: formatCustomDate(seriesId?.added_on),
                      firstItem: "Remove",
                      secondItem: "Modify Target Date",
                      showDelete: false,
                    };

                    return (
                      <div
                        key={seriesId?.id || index}
                        style={style}
                        className="pointer user-list__card"
                      >
                        <EnrolledUserGroups
                          {...groupData}
                          onDropdownClick={val => {
                            if (val === "item1") {
                              setModalType("remove_user_group");
                            } else {
                              setFormValues({
                                start_date: seriesId?.start_date
                                  ? new Date(seriesId?.start_date)
                                  : new Date(),
                                end_date: seriesId?.end_date
                                  ? new Date(seriesId?.end_date)
                                  : new Date(),
                              });
                              setModalType("modify_target_date");
                            }
                            setSelectedId(seriesId?.id);
                            toggleModal();
                          }}
                          toggleSliderModal={async () => {
                            await dispatch(
                              getUserGroupById({ id: seriesId?.id })
                            );
                            toggleSliderModal();
                          }}
                        />
                      </div>
                    );
                  }}
                </List>
              )}
            </CardBody>
          </Card>
        </Col>
        <Col lg="4" md="12" sm="12" xs="12">
          <Card>
            <CardBody>
              <H3 className="mt-2">Progress</H3>
              <Divider />
              <div className="mt-2">
                <div className="d-flex gap-2">
                  <H2 className="fw-bold">
                    {learningPlanDetailsById?.progress?.total}
                  </H2>
                  <P className="text-muted mt-1">Activities</P>
                </div>
              </div>
              <div className="mt-3 mb-2">
                <MultiProgressBar
                  showProgress={false}
                  progressBars={learningPlanMultiProgressData(
                    learningPlanDetailsById?.progress?.yts,
                    learningPlanDetailsById?.progress?.in_progress,
                    learningPlanDetailsById?.progress?.completed
                  )}
                />
                <Row className="mt-3">
                  {progressStats.map((stat, index) => (
                    <Col lg="4" md="4" sm="12" xs="12" key={index}>
                      <CompletionStatus
                        label={stat.label}
                        percentage={stat.percentage}
                        statusColor={stat.statusColor}
                      />
                    </Col>
                  ))}
                </Row>
              </div>
            </CardBody>
          </Card>
          <SimpleAccordion accordionList={accordionData} />
        </Col>
      </Row>
    </div>
  );
};

export default LearningPlanDetails;
